import { useState } from 'react'
import { Form } from 'antd'

const useBedModals = () => {
  const [isAssignModalVisible, setIsAssignModalVisible] = useState(false)
  const [isTransferModalVisible, setIsTransferModalVisible] = useState(false)
  const [selectedBed, setSelectedBed] = useState(null)
  const [form] = Form.useForm()

  const showAssignModal = (bed) => {
    setSelectedBed(bed)
    setIsAssignModalVisible(true)
  }

  const showTransferModal = (bed) => {
    setSelectedBed(bed)
    setIsTransferModalVisible(true)
  }

  const handleCancel = () => {
    setIsAssignModalVisible(false)
    setIsTransferModalVisible(false)
    form.resetFields()
  }

  const handleAssign = () => {
    form
      .validateFields()
      .then((values) => {
        // In a real app, this would update the bed assignment in the database
        setIsAssignModalVisible(false)
        form.resetFields()
      })
      .catch((info) => {})
  }

  const handleTransfer = () => {
    form
      .validateFields()
      .then((values) => {
        // In a real app, this would handle the bed transfer in the database
        setIsTransferModalVisible(false)
        form.resetFields()
      })
      .catch((info) => {})
  }

  return {
    isAssignModalVisible,
    isTransferModalVisible,
    selectedBed,
    form,
    showAssignModal,
    showTransferModal,
    handleCancel,
    handleAssign,
    handleTransfer
  }
}

export default useBedModals
